type Props = {
  children: React.ReactNode;
  color?: 'default' | 'black';
  customFont?: boolean;
  heading?: boolean;
  lineClamp?: number;
  size?: 'default' | 'small' | 'medium';
  styles?: string;
  titleBold?: boolean;
  titleSize?: string;
  titleTracking?: string;
  titleUpperCase?: boolean;
};

export default function TitleH2({
  children,
  color = 'default',
  heading = true,
  size = 'default',
  customFont = false,
  styles = '',
  titleUpperCase = true,
  titleBold = false,
  titleTracking = 'tracking-tight',
  titleSize = '',
}: Props) {
  const fontColor = color === 'black' ? 'text-neutral-900' : 'text-neutral-50';
  let textSize =
    size === 'default' ? 'text-[35px] leading-[33px] lg:text-5xl' : 'text-xl lg:text-2xl';
  if (size === 'medium') {
    textSize = 'text-[35px] tracking-wide leading-9';
  }
  const customFontFamily = customFont ? 'font-AgencyFBBlackComp antialiased' : '';
  const uppercase = titleUpperCase ? 'uppercase' : '';
  const bold = titleBold && !customFont ? 'font-semibold' : '';

  textSize = titleSize || textSize;

  const className = `relative ${styles} ${textSize} ${customFontFamily} ${bold} ${uppercase} ${fontColor} ${titleTracking} antialiased`;

  if (!heading) {
    return <span className={className}>{children}</span>;
  }
  return <h2 className={className}>{children}</h2>;
}
